export const WORDS = [
	"AGENT",
	"WORLD",
	"ABOUT",
	"HEART",
	"WATER",
	"SIXTY",
	"BOARD",
	"MONTH",
	"MUSIC",
	"PARTY",
	"PIANO",
	"MOUTH",
	"WOMAN",
	"SUGAR",
	"AMBER",
	"DREAM",
	"LAUGH",
	"TIGER",
	"EARTH",
	"MONEY",
	"WORDS",
	"SMILE",
	"LEMON",
	"SOUTH",
	"AFTER",
	"STONE",
	"THING",
	"LIGHT",
	"STORY",
	"POWER",
	"TODAY",
	"RANGE",
	"PEARL",
	"VENOM",
	"PROXY",
	"ROUND",
	"HOVER",
	"CANDY",
	"ABOVE",
	"PHONE",
	"OTHER",
	"SMART",
	"BLACK",
	"MAGIC",
	"FRUIT",
	"RADIO",
	"ROYAL",
	"HONEY",
	"FLAKE",
	"SOUND",
];
